export default __webpack_public_path__ + "static/media/yash_and_radhika.f2aa20ca.jpg";